export default __webpack_public_path__ + "static/1834-8ad6215cb885f66205fc5d633223f619.gif";